const cancelModel = {};
cancelModel.install = Vue => {
    Vue.directive('cancelmodel', {
        mounted: function (el, binding) {
            function handler(e) {
                if (
                    el && binding.arg &&
                    (el.contains(e.target) || 
                    e.target.className?.includes(binding.arg))
                ) {
                    return false;
                }
                if (binding.value) {
                    binding.value(e);
                }
            }
            el._zClickOutside = handler;
            document.addEventListener("click", handler);

        },
        unmounted: function (el) {
            // 解除事件监听
            document.removeEventListener("click", el._zClickOutside);
            delete el._zClickOutside;
        }
    });
};

export default cancelModel;
